import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const sectionsAdapter = createEntityAdapter({})

const initialState = sectionsAdapter.getInitialState()

export const sectionsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSections: builder.query({
            query: () => ({
                url: '/sections/getSections',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedSections = responseData.map(section => {
                    section.id = section._id
                    return section
                })
                return sectionsAdapter.setAll(initialState, loadedSections)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'Section', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'Section', id}))
                    ]
                } else {
                    return [ { type: 'Section', id: 'LIST'}]
                }
            },
        }),
        createNewSection: builder.mutation({
            query: initialSection => ({
                url: '/sections/createNewSection',
                method: 'POST',
                body: {...initialSection,}
            }),
            invalidatesTags: [
                { type: 'Section', id: "LIST" }
            ] 
        }),
        updateSection: builder.mutation({
            query: initialSection => ({
                url: '/sections/updateSection',
                method: 'PATCH',
                body: {...initialSection,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'Section', id: arg.id },
                { type: 'Section', id: 'LIST' }
            ],
        }),
        deleteSection: builder.mutation({
            query: ({id}) => ({
                url: '/sections/deleteSection',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Section', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetSectionsQuery,
    useCreateNewSectionMutation,
    useUpdateSectionMutation,
    useDeleteSectionMutation,
} = sectionsApiSlice

// returns the query result object
export const selectSectionResult = sectionsApiSlice.endpoints.getSections.select()

// create memoized selector
const selectSectionsData = createSelector(
    selectSectionResult,
    sectionResult => sectionResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllSections,
    selectById: selectSectionById,
    selectIds: selectSectionIds,
} = sectionsAdapter.getSelectors(state => selectSectionsData(state) ?? initialState)